import {values} from 'lodash'
import {DeviceTypes} from 'utility/utility'
import {object, string, array, boolean} from 'yup'
import {
  getDefaultOperationalHours,
  getDefaultOptions,
  getDefaultSignageOptions
} from './constants'

export const DeviceBasicSchema = object().shape({
  name: string().when('type', {
    is: value => value === DeviceTypes.OFFICE,
    then: () => string().required('Device name is required for office device.'),
    otherwise: () => string().optional()
  }),
  user: string().when('type', {
    is: value => value === DeviceTypes.REMOTE,
    then: () => string().required('User is required for remote device creation.'),
    otherwise: () => string().optional()
  }),
  nickname: string().optional(),
  floor: string().optional(),
  city: string().required('City is required, Search and select from existing or create new'),
  country: string().required('Country is required'),
  timezone: string().required('Timezone is required')
})

export const DeviceSchema = object().shape({
  name: string().when('type', {
    is: value => value === DeviceTypes.OFFICE,
    then: () => string().required('Device name is required.'),
    otherwise: () => string().optional()
  }),
  user: string().when('type', {
    is: value => value === DeviceTypes.REMOTE,
    then: () => string().required('User is required for remote device creation.'),
    otherwise: () => string().optional()
  }),
  nickname: string().optional(),
  floor: string().optional(),
  city: string().optional(),
  country: string().optional(),
  timezone: string().optional(),
  type: string().oneOf(values(DeviceTypes)).required('Device type is required'),
  distributor: string().optional(),
  reseller: string().optional(),
  business: string().required('Device must be associated with business'),
  groups: array().min(1, 'Select minimum one device group.').required('Device groups is required'),
  operationalHours: array().optional(),
  options: object().optional(),
  showDigitalSignage: boolean().optional(),
  digitalSignage: object().optional(),
  siteContacts: array().optional()
})

export const DevicePrototype = (isOfficeDevice = false, business) => ({
  name: '',
  nickname: '',
  floor: '',
  city: '',
  country: '',
  timezone: '',
  type: isOfficeDevice ? DeviceTypes.OFFICE : DeviceTypes.REMOTE,
  distributor: '',
  reseller: '',
  business,
  groups: [],
  operationalHours: getDefaultOperationalHours(isOfficeDevice),
  options: getDefaultOptions(isOfficeDevice),
  allowBrowser: false,
  browserOptions: [],
  showDigitalSignage: false,
  digitalSignage: getDefaultSignageOptions(isOfficeDevice),
  siteContacts: []
})
